import React, { Component } from "react";
import TableGrid from "../../components/UI/TableGrid";
import { ToastContext } from "../../context/ToaxtContext";
import {
  isSet,
  toQueryString,
  getShortenedVisitCategoryName,
  formatDate,
  isObject,
} from "../../utils/commonUtils";
import Buttons from "../../components/UI/Buttons";
import WithRoutify from "../../hoc/WithRoutify";
import VisitsService from "../../services/VisitsService";
import withReduxState from "../../hoc/wReduxState";
import EmployeeDetails from "../EmployeeContainer/EmployeeDetails";
import LookupService from "../../services/LookupService";
import AddEmployee from "../EmployeeContainer/AddEmployee";
import { VISIT_STATUS } from "../../utils/constant";
import WithRouter from "../../hoc/WithRouter";
import PERMISSIONS from "../../utils/AclPermissions";
import MiniPopup from "../../components/Modal/MiniPopup";
import Acl from "../../hoc/Acl";
import { getActiveIds, isWorkCompVisitCategory } from "../../utils/visitUtils";
import { isLaboratoryVisitCategory } from "../../utils/visitUtils";
import ScanbarCodePopup from "../EmployeeContainer/ScanbarCodePopup";
import AddVisits from "../EmployeeVisitContainer/AddVisits";
import VisitDetails from "../EmployeeVisitContainer/VisitDetails";
import AddFollowUp from "../EmployeeVisitContainer/AddFollowUp";
import AddPhysical from "../EmployeeVisitContainer/AddPhysical";
import AddLab from "../EmployeeVisitContainer/AddLab";
import DischargeAndWaiting from "../AppointmentsContainer/DischargeAndWaiting";
import FutureAppointments from "../AppointmentsContainer/FutureAppointments";
import CalendarWidget from "../AppointmentsContainer/CalendarWidget";
import { fetchCurrentDate } from "../../utils/DateUtils";
import WithDropdownState from "../../hoc/WithDropdownState";
import FormInputs from "../../components/UI/FormInputs";
import DropDownService from "../../services/DropDownService";
import NewDischargeAndWaiting from "../AppointmentsContainer/NewAppointmentsContainer/NewDischargeAndWaiting";
import NewFutureAppointments from "../AppointmentsContainer/NewAppointmentsContainer/NewFutureAppointments";
import GlobalSearch from "../../components/Layouts/NewAppLayout/GlobalSearch/GlobalSearch";
import SendTaskModal from "../../components/Modal/SendTaskModal";
import TranscriptionRecordingModal from "../EmployeeVisitContainer/NewUIVisitList/TranscriptionRecordingModal";
import {
  getVoiceToolbarUi,
  isVoiceTranscriptionListCategory,
  voiceDocProgressFromVisitListRow,
} from "../../utils/transcriptionUtils";

class NewWhiteboardList extends Component {
  static contextType = ToastContext;
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        first_name: "",
        last_name: "",
        gender: "",
        company_id: "",
        dob: "",
        visit_status: "",
        is_scheduled_visit: "ALL",
        patient_id: "",
        clinic_location_id: "",
        phone: "",
        patient_id: "",
        identification_type: "",
        identification_number: "",
        clinic_id: "",
        booking_id: "",
        pre_registration_code: "",
      },
      tableRecords: {
        tableHeaders: [],
        tableRows: {
          data: [],
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "visit_date",
          sort_order: "desc",
        },
      },
      formDataInEdit: {},
      activeEditId: null,
      isModelOpen: false,
      isAddPatientModelOpen: false,
      detailViewId: null,
      isDetailViewOpen: false,
      organization_id: "",
      filterOpen: false,
      visitsAutoFillData: {},
      visitDetailViewId: null,
      isVisitDetailViewOpen: false,
      activeLabId: null,
      isLabModelOpen: false,
      isPhysicalModelOpen: false,
      isFollowUpModelOpen: false,
      snapClinicConsentForm: null,
      snapVisitConsentForm: null,
      snapEmployeeDetails: null,
      selectedAllRecords: false,
      Tab: [
        // { "label": "Active", isActive: true, name: 'Active' },
        // { "label": "Dischrg", isActive: false, name: 'Discharge' },
        { label: "All", isActive: true, name: "" },
        { label: "Discharged", isActive: false, name: "Complete & Discharged" },
        { label: "Interface", isActive: false, name: "In Active" },
      ],
      scheduledType: [
        { label: "All", isActive: true, name: "ALL" },
        { label: "Scheduled", isActive: false, name: "true" },
        { label: "Walk In", isActive: false, name: "false" },
      ],
      isMiniPopupOpen: false,
      selectedVisitId: null,
      selectedVisitStatus: null,
      scanBarcodeModalOpen: false,
      autoEmployeeFillData: {},
      clinicOptions: [],
      currentDay: null,
      calendarViewType: "WEEK",
      isCalendarWidgetDate: null,
      calendarRecords: [],
      calendarParam: { from_date: "", to_date: "" },
      dailyTotalVisits: 0,
      inProgressCount: 0,      
      pendingResultsCount: 0,  
      completedCount: 0,    
      activeCustomFilter: {},
      activeCard: 'TOTAL',
      sendTaskModalOpen: false,
      selectedVisitNavigationLink: null,
      showTranscriptionModal: false,
      transcriptionVisitId: null,
      transcriptionVisitData: null,
    };
  }

async componentDidMount() {
  if (this.props.location?.state) {
    this.setState(
      { currentDay: this.props.location.state.currentDay },
      () => {
        this.fetchVisitsList();
        this.fetchDailyTotalCount(); 
        this.fetchStatusCounts();
      }
    );
    // this.fetchVisitStatus()
  } else {
    this.setState({ currentDay: fetchCurrentDate() }, () => {
      this.fetchVisitsList();
      this.fetchDailyTotalCount(); 
      this.fetchStatusCounts();
      // this.fetchVisitStatus()
    });
  }
  this.fetchClinicOptions();
}
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isModelOpen !== this.props.isModelOpen) {
      this.addVisitToogleHandler();
    }
    if (prevProps.visitsAutoFillData !== this.props.visitsAutoFillData) {
      this.setState({ visitsAutoFillData: this.props.visitsAutoFillData });
    }
    if (prevState.currentDay != this.state.currentDay) {
      this.fetchVisitsList();
      this.fetchDailyTotalCount();
      this.fetchStatusCounts();
    }
    if (
      prevProps.globalFilter?.["White Board"] !==
      this.props?.globalFilter?.["White Board"]
    ) {
      this.fetchVisitsList();
      this.fetchDailyTotalCount();
      this.fetchStatusCounts();
    }
    if (prevState.filters.clinic_id !== this.state.filters.clinic_id) {
      this.fetchDailyTotalCount();
      this.fetchStatusCounts();
    }
     if (prevState.filters.is_scheduled_visit !== this.state.filters.is_scheduled_visit) {
      this.fetchStatusCounts();
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("filterOpened");
    // Code to run before the component is unmounted
  }

  handleEvent = () => {
    // Handler for events (e.g., button click)
  };
  addVisitToogleHandler = (emptyAutoFillData = false) => {
    let updatedState = { ...this.state };
    if (emptyAutoFillData) {
      updatedState = { ...updatedState, ["visitsAutoFillData"]: {} };
    } else {
      updatedState = {
        ...updatedState,
        ["visitsAutoFillData"]: {
          visit_date: formatDate(this.state.currentDay),
        },
      };
    }
    updatedState = {
      ...updatedState,
      ["isModelOpen"]: !this.state.isModelOpen,
    };
    this.setState(updatedState);
  };
  scanBarcodeHandler = (obj = {}, isAddEmployee = false) => {
    this.setState({
      scanBarcodeModalOpen: !this.state.scanBarcodeModalOpen,
      autoEmployeeFillData: obj,
      isAddPatientModelOpen: isAddEmployee,
    });
  };
  addNewEmployeeToogleHandler = (
    bool = false,
    nextStep = null,
    autoFillData
  ) => {
    if (nextStep === "ADD_VISIT") {
      this.setState(
        {
          visitsAutoFillData: autoFillData,
          isAddPatientModelOpen: bool,
        },
        this.addVisitToogleHandler()
      );
    } else {
      this.setState({
        isAddPatientModelOpen: bool,
      });
    }
  };
  openMiniPopup = (visitId, visitStatus) => {
    this.setState({
      isMiniPopupOpen: true,
      selectedVisitStatus: visitStatus,
      selectedVisitId: visitId,
    });
  };
  fetchClinicOptions = async (val = null) => {
    try {
      const response = await DropDownService.getClinicList(val);
      console.log("fetchClinicOptions", response);

      const clinicOptions = [{ label: "-Select Clinic-", value: "" }];

      if (Array.isArray(response)) {
        response.forEach((clinic) => {
          clinicOptions.push({
            label: clinic.name,
            value: clinic.clinic_id,
          });
        });
        
      if (clinicOptions.length === 2) {
        const singleClinicId = clinicOptions[1].value;
        this.setState(
          (prevState) => ({
            clinicOptions,
            filters: {
              ...prevState.filters,
              clinic_id: singleClinicId,
            },
          }),
          this.submitFiltersHandler // fetch data after setting
        );
        return;
      }
      } else if (response?.message === "Unauthenticated.") {
        // handle unauthenticated case
        console.warn("User not authenticated. Redirecting to login...");
        // example: window.location.href = "/login";
      } else {
        console.error("Unexpected response format:", response);
      }

      this.setState({ clinicOptions });
    } catch (error) {
      console.error("Error fetching clinic options:", error);
      this.setState({
        clinicOptions: [{ label: "Error fetching clinics", value: "" }],
      });
    }
  };

  closeMiniPopup = () => {
    this.setState({
      isMiniPopupOpen: false,
      selectedVisitId: null,
      selectedVisitStatus: null,
    });
  };
  //fetch the totalvisits in the whiteboardlist
  fetchDailyTotalCount = async () => {
  try {
    const { currentDay,filters } = this.state;
    const { globalFilter } = this.props; 
    const date = formatDate(currentDay);
    const query = {
      visit_from: date,
      visit_to: date,
      visit_status: "",
      page: 1,
      perPage: 1,
      clinic_id: filters.clinic_id,
      ...globalFilter?.["White Board"] 
    };
   const response = await VisitsService.getVisitsList(query);

    if (response && response.pagination) {
      this.setState({ dailyTotalVisits: response.pagination.totalCount });
    }
  } catch (error) {
    console.error("Error fetching daily total count:", error);
  }
};
//card count status function
fetchStatusCounts = async () => {
  try {
    const { currentDay, filters } = this.state;
    const { globalFilter } = this.props; 
    const date = formatDate(currentDay);
    const baseQuery = {
      visit_from: date,
      visit_to: date,
      clinic_id: filters.clinic_id,
      is_scheduled_visit: filters.is_scheduled_visit,
      page: 1,
      perPage: 1, 
      ...globalFilter?.["White Board"],
    };
    const totalQuery = { ...baseQuery, visit_status: "" }; 
    const newQuery = { ...baseQuery, visit_status: "New" };
    const completedQuery = { ...baseQuery, visit_status: "Complete & Discharged" };
    const pendingQuery = { ...baseQuery, visit_status: "Ready for Discharge" };
    const cancelledQuery = { ...baseQuery, visit_status: "Cancelled" };
    const noShowQuery = { ...baseQuery, visit_status: "No Show" };
    const [totalRes, newRes, completedRes, pendingRes, cancelledRes, noShowRes] = await Promise.all([
      VisitsService.getVisitsList(totalQuery),
      VisitsService.getVisitsList(newQuery),
      VisitsService.getVisitsList(completedQuery),
      VisitsService.getVisitsList(pendingQuery),
      VisitsService.getVisitsList(cancelledQuery),
      VisitsService.getVisitsList(noShowQuery),
    ]);
    const totalCount = totalRes?.pagination?.totalCount || 0;
    const newCount = newRes?.pagination?.totalCount || 0;
    const completedCount = completedRes?.pagination?.totalCount || 0;
    const pendingCount = pendingRes?.pagination?.totalCount || 0;
    const cancelledCount = cancelledRes?.pagination?.totalCount || 0;
    const noShowCount = noShowRes?.pagination?.totalCount || 0;
    const inProgressCalculated = totalCount - (newCount + completedCount + cancelledCount + noShowCount);
    this.setState({
      inProgressCount: inProgressCalculated < 0 ? 0 : inProgressCalculated, 
      pendingResultsCount: pendingCount, 
      completedCount: completedCount,    
    });

  } catch (error) {
    console.error("Error fetching status counts:", error);
  }
};
//filter function based on card status 
handleStatusCardClick = (type) => {
    let status = "";
    let customFilter = {};
    switch (type) {
      case "TOTAL":
       status = "";
        customFilter = {};
        break;
      case "PENDING":
        status = "Ready for Discharge";
        customFilter = {};
        break;
      case "COMPLETED":
        status = "Complete & Discharged";
        customFilter = {};
        break;
      case "IN_PROGRESS":
        status = ""; 
        customFilter = {
          exclude_visit_status: "New,Complete & Discharged,Cancelled,No Show"         
        };
        break;

      default:
        status = "";
    }
   this.setState(
      (prevState) => ({
        activeCard: type,
        filters: {
          ...prevState.filters,
          visit_status: status,
        },
        activeCustomFilter: customFilter,
        tableRecords: {
          ...prevState.tableRecords,
          pagination: { ...prevState.tableRecords.pagination, page: 1 }, 
        },
      }),
      this.submitFiltersHandler
    );
  };
  render() {
    const { params } = this.props;
    const {
      tableRecords,
      isModelOpen,
      isAddPatientModelOpen,
      visitCategoryOptions,
      isDetailViewOpen,
      visitsAutoFillData,
      detailViewId,
      isVisitDetailViewOpen,
      visitDetailViewId,
      companiesOptions,
      visitStatusOption,
      isLabModelOpen,
      snapEmployeeDetails,
      Tab,
      scheduledType,
      isFollowUpModelOpen,
      isPhysicalModelOpen,
      isMiniPopupOpen,
      selectedVisitId,
      selectedVisitStatus,
      selectedAllRecords,
      autoEmployeeFillData,
      activeCard,
      filters,
      currentDay,
      showTranscriptionModal,
      transcriptionVisitId,
      transcriptionVisitData,
    } = this.state;
    const isPatientHistory =
      isSet(params.patientId, null) !== null ? true : false;
      // Add a GlobalSearchFilter paths
    const globalSearchFilter = [
      "/visits",
      "/appointments",
      "/white-board",
      "/labs",
      "/result/vaccine",
      "/result/physical-drug-screens",
      "/employee",
    ];
    const { profile, location } = this.props;
    const { pathname } = location;
    return (
      <>
        {isAddPatientModelOpen ? (
          <AddEmployee
            modelTitle={"Add Employee"}
            isFromVisitHistory={this.props.isFromVisitHistory}
            fetchEmployeeList={this.fetchVisitsList}
            isOpen={isAddPatientModelOpen}
            autoEmployeeFillData={autoEmployeeFillData}
            modalToogleHandler={this.addNewEmployeeToogleHandler}
            companiesOptions={this.state.companiesOptions}
          />
        ) : isModelOpen ? (
          <AddVisits
            modelTitle={"Add Visits"}
            fetchVisitsList={async () => {
            await this.fetchVisitsList();      
            this.fetchDailyTotalCount(); 
            this.fetchStatusCounts();      
            }}
            isOpen={isModelOpen}
            autoFillData={visitsAutoFillData}
            modalToogleHandler={this.addVisitToogleHandler}
            visitCategoryOptions={visitCategoryOptions}
            companiesOptions={this.state.companiesOptions}
          />
        ) : isDetailViewOpen ? (
          <EmployeeDetails
            modalToogleHandler={this.detailViewModal}
            fetchEmployeeList={() => {}}
            employeeId={detailViewId}
          />
        ) : (
          <></>
        )}
        {isVisitDetailViewOpen ? (
          <VisitDetails
            isOpen={isVisitDetailViewOpen}
            visitId={visitDetailViewId}
            modalToogleHandler={this.visitDetailViewModal}
            fetchDetails={this.fetchVisitsList}
            snapEmployeeDetails={snapEmployeeDetails}
          />
        ) : (
          ""
        )}
        {isMiniPopupOpen && (
          <MiniPopup
            isOpen={isMiniPopupOpen}
            onClose={this.closeMiniPopup}
            onUpdate={this.handleUpdateStatus}
            visitId={selectedVisitId}
            fetchVisitsList={this.fetchVisitsList}
            selectedVisitStatus={selectedVisitStatus}
          />
        )}
        {isLabModelOpen ? (
          <AddLab
            modelTitle={"Add Lab"}
            isOpen={isLabModelOpen}
            visitId={visitDetailViewId}
            modalToogleHandler={this.addLabToogleHandler}
            fetchRecords={this.fetchVisitsList}
          />
        ) : (
          ""
        )}
        {isFollowUpModelOpen ? (
          <AddFollowUp
            modelTitle={"Follow Up"}
            visitId={visitDetailViewId}
            isOpen={isFollowUpModelOpen}
            modalToogleHandler={this.followUpModelHandler}
            fetchRecords={this.fetchVisitsList}
          />
        ) : (
          ""
        )}
        {isPhysicalModelOpen ? (
          <AddPhysical
            modelTitle={"Add Physical / Drug Screen"}
            isOpen={isPhysicalModelOpen}
            visit_id={visitDetailViewId}
            fetchRecords={this.fetchVisitsList}
            modalToogleHandler={this.addPhysicalToogleHandler}
          />
        ) : (
          ""
        )}
        {this.state.scanBarcodeModalOpen && (
          <ScanbarCodePopup modleToogleHandler={this.scanBarcodeHandler} />
        )}
        {this.state.sendTaskModalOpen && (
          <SendTaskModal
            isOpen={this.state.sendTaskModalOpen}
            modalToogleHandler={() =>
              this.setState({
                sendTaskModalOpen: false,
                selectedVisitNavigationLink: null,
              })
            }
            Toast={this.props.Toast}
            Loader={this.props.Loader}
            navigationLink={this.state.selectedVisitNavigationLink}
          />
        )}
        <TranscriptionRecordingModal
          isOpen={showTranscriptionModal && !!transcriptionVisitId}
          visitId={transcriptionVisitId}
          visitData={transcriptionVisitData}
          profile={this.props.profile}
          onClose={this.closeTranscriptionModal}
          Toast={this.props.Toast}
          Loader={this.props.Loader}
        />
        <div className="sh_cardBox ">
          <div className="sh_cardHeader pb-0">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <h2 className="h2-strong mb-0 position-absolute sh_welcome-text">White Board</h2>
              {profile &&
                profile.is_multiple_organization === false &&
                profile.employee_login === false &&
                globalSearchFilter.some((path) => pathname.startsWith(path)) && (
                  <GlobalSearch
                    activeMenu={"White Board"}
                    pathname={pathname}
                  />
                )}
            </div>
          </div>
          <div className="sh_cardBody p-0">       
        <div className="row h-100 ">
          <div
            className="col-12 col-md-3 pt-2"
            style={{
              height: "calc(100vh - 95px)",
              overflowY: "auto",
              scrollbarWidth: "thin",
            }}
          >
            <CalendarWidget
              currentDay={this.state.currentDay}
              calendarViewType={this.state.calendarViewType}
              setCurrentDate={this.setCurrentDate}
            />
            <NewDischargeAndWaiting
              fromWhiteBoard={true}
              fetchDetails={this.fetchVisitsList}
              calendarRecords={this.state.calendarRecords}
              is_scheduled_visit={this.state.filters.is_scheduled_visit}
              clinic_id={this.state.filters.clinic_id}
              currentDay={this.state.currentDay}
            />
            <NewFutureAppointments
              calendarRecords={this.state.calendarRecords}
            />
          </div>
          <div
            className="col-md-9 col-12 pt-2"
            style={{ height: "calc(100vh - 95px)" }}
          >
            <div className="sh_cardBox  sh-calendarht sh_cardbglight" id="sh_cardBox">
              <div className="sh_cardHeader pb-1">
                <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                  <div>
                    <div className="tabs_wrapForTable">
                      <ul className="nav nav-borders nav-tabs border-0" role="">
                        {Tab.map((itm, itmInd) => {
                          return (
                            <>
                              <li>
                                <a
                                  className={`flex-sm-fill text-sm-center nav-link ${
                                    itm.isActive ? "active" : ""
                                  }`}
                                  aria-current="page"
                                  onClick={() => this.setActiveTab(itm)}
                                >
                                  {itm.label}
                                </a>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                  {/* <h6 class="text-lg f-500 mb-0">{` Employee / Patient Visits `} </h6> */}
                  <div className="d-flex">
                    {/* <div className="d-flex align-items-center">
                <div className="sheduletoggle-input">
                    {scheduledType.map((itm, itmInd) => (
                      <label className="sheduled_radio mb-0" key={itmInd}>
                        <FormInputs
                          type="Radio"
                          name="scheduleType"
                          // className=" "
                          value={itm.isActive}
                          changeHandler={() => this.setActiveScheduled(itm)}
                        />
                        <span className="name font-weight-bold">{itm.label}</span>
                      </label>
                    ))}
                  </div>
                  </div> */}

                    <div className="d-flex gap-2">
                      <span className="">
                        <Buttons
                          iconType="NewQrIcon"
                          clickHandler={this.scanBarcodeHandler}
                          className="btn btn-light sh_btnlight rsp-icon-only-btn"
                          acl={PERMISSIONS.WHITE_BOARD.SCAN_BARCODE}
                          label={"  Scan barcode"}  
                          title="Scan barcode"
                        />
                      </span>
                      <span className="">
                        <Buttons
                          iconType="NewAddVisitIcon"
                          clickHandler={this.addVisitToogleHandler}
                          className="btn btn-primary sh_btnprimary rsp-icon-only-btn"
                          acl={PERMISSIONS.VISITS.CREATE}
                          // appendAddIcon={true}
                          label={"  Add New Visit"}
                          title="Add New Visit"
                        />
                      </span>

                      <span className="">
                        <Buttons
                          iconType="NewAddPatientIcon"
                          clickHandler={() =>
                            this.addNewEmployeeToogleHandler(true)
                          }
                          className="btn btn-primary sh_btnprimary rsp-icon-only-btn"
                          acl={PERMISSIONS.EMPLOYEE.CREATE}
                          // appendAddIcon={true}
                          label={"  Add Patient"} 
                          title="Add Patient"
                        />
                      </span>
                    <FormInputs
                      type="SelectList"
                      value={filters["clinic_id"]}
                      changeHandler={(val) => {
                        this.onChangeFiltersHandler("clinic_id", val);
                        // this.fetchVisitsList(filters);
                      }}
                      options={this.state.clinicOptions}
                      className="form-control mx-1 mr-2"
                    />
                                        <div className="btn-group">
                      <Acl
                        acl={
                          this.anyCheckboxSelected() == true
                            ? PERMISSIONS.WHITE_BOARD.DELETE
                            : ""
                        }
                      >
                        <Buttons
                          clickHandler={() => this.deleteHandler(null, true)}
                          className="btn btn-primary"
                          isDelete={true}
                          label={"Delete"}
                          contentTitle={"Warning"}
                          content={
                            "Selected visits may have associated activities. Are you sure you want to delete the records?"
                          }
                        />
                      </Acl>
                    </div>
                    </div>


                    {/* <Buttons
                    clickHandler={() =>
                      this.addNewEmployeeToogleHandler(true)
                    }
                    className="btn btn-primary ml-1"
                    acl={"employee-create"}
                    label={"Add Patient"}
                  /> */}
                    {/* <Buttons
                            clickHandler={this.scanBarcodeHandler}
                            className="btn btn-primary ml-1"
                            acl={"employee-create"}
                            label={"Scan barcode"}
                          /> */}
                  </div>
                </div>
                <div className="form-group d-flex mb-0 justify-content-end align-items-center mt-1">
                  <div className="tabs_wrapForTable">
                    <ul className="nav sh_subnav border-0">
                      {scheduledType.map((itm, itmInd) => (
                        <li key={itmInd}>
                          <a
                            href="#"
                            className={`flex-sm-fill text-sm-center text-dark nav-link ${
                              itm.isActive ? "active" : ""
                            }`}
                            aria-current={itm.isActive ? "page" : undefined}
                            onClick={(e) => {
                              e.preventDefault();
                              this.setActiveScheduled(itm);
                            }}
                          >
                            {itm.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              {/* White board card start here  */}
              <div className="sh_cardHeader px-0">
                <div className="row">
                  <div className="col-lg-3 py-1 col-md-6 col-12">
                    <div className={`d-flex sh_statusIndicatorbox blue-orichid px-3 py-2 ${activeCard === 'TOTAL' ? 'border  shadow-sm' : ''}`}
                    onClick={() => this.handleStatusCardClick("TOTAL")} 
                    style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center ">
                        <span className="sh_statusIndicator bg-light">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M16 3V6"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12 3V6"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8 3V6"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12 16H17"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8.63389 15.1161C9.12204 15.6043 9.12204 16.3957 8.63389 16.8839C8.14573 17.372 7.35428 17.372 6.86612 16.8839C6.37796 16.3957 6.37796 15.6043 6.86612 15.1161C7.35427 14.628 8.14573 14.628 8.63389 15.1161"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12 11H17"
                              stroke="#323232"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8.63389 10.1161C9.12204 10.6043 9.12204 11.3957 8.63389 11.8839C8.14573 12.372 7.35428 12.372 6.86612 11.8839C6.37796 11.3957 6.37796 10.6043 6.86612 10.1161C7.35427 9.62796 8.14573 9.62796 8.63389 10.1161"
                              stroke="#323232"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      <div className="d-flex flex-column">
                        <p className="p1-light text-dark mb-0">
                          Total Visit Today
                        </p>
                        <h3 className="h3-strong mb-0">{this.state.dailyTotalVisits}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 py-1 col-md-6 col-12">
                    <div className={`d-flex sh_statusIndicatorbox pale-purple px-3 py-2 ${activeCard === 'IN_PROGRESS' ? 'border  shadow-sm' : ''}`}
                    onClick={() => this.handleStatusCardClick("IN_PROGRESS")}
                    style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center ">
                        <span className="sh_statusIndicator bg-light">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 3V6"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M16.5 3V6"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 21H6C4.34315 21 3 19.6569 3 18V7.5C3 5.84315 4.34315 4.5 6 4.5H18C19.6569 4.5 21 5.84315 21 7.5V10"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M17.8685 18.7361L16.6309 17.4989L17.8685 16.2617"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle
                              cx="17.5"
                              cy="17.5"
                              r="4.5"
                              stroke="#1D1917"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      <div className="d-flex flex-column">
                        <p className="p1-light text-dark mb-0">In Progress</p>
                        <h3 className="h3-strong mb-0">{this.state.inProgressCount}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 py-1 col-md-6 col-12">
                    <div className={`d-flex sh_statusIndicatorbox linear_gradient px-3 py-2 ${activeCard === 'PENDING' ? 'border  shadow-sm' : ''}`}
                    onClick={() => this.handleStatusCardClick("PENDING")} 
                    style={{ cursor: "pointer" }} 
                    >
                      <div className="d-flex align-items-center ">
                        <span className="sh_statusIndicator bg-light">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 18H14"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M16.9775 3H7.01953C6.46753 3 6.01953 3.448 6.01953 4V6.378C6.01953 6.799 6.15253 7.21 6.39953 7.551L9.61953 12L6.39953 16.449C6.15253 16.79 6.01953 17.201 6.01953 17.622V20C6.01953 20.552 6.46753 21 7.01953 21H16.9765C17.5285 21 17.9765 20.552 17.9765 20V17.658C17.9765 17.214 17.8285 16.783 17.5565 16.432L14.1195 12L17.5575 7.567C17.8295 7.216 17.9775 6.785 17.9775 6.341V4C17.9775 3.448 17.5295 3 16.9775 3Z"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      <div className="d-flex flex-column">
                        <p className="p1-light text-dark mb-0">
                          Pending Results{" "}
                        </p>
                        <h3 className="h3-strong mb-0">{this.state.pendingResultsCount}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 py-1 col-md-6 col-12">
                    <div className={`d-flex sh_statusIndicatorbox olivegreen px-3 py-2 ${activeCard === 'COMPLETED' ? 'border  shadow-sm' : ''}`}
                    onClick={() => this.handleStatusCardClick("COMPLETED")}
                    style={{ cursor: "pointer" }} 
                    >
                      <div className="d-flex align-items-center ">
                        <span className="sh_statusIndicator bg-light">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11 3H6C4.34315 3 3 4.34315 3 6V9"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M17 21H18C19.6569 21 21 19.6569 21 18V13"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <ellipse
                              cx="17"
                              cy="7"
                              rx="4"
                              ry="4"
                              stroke="#323232"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M18.25 6.5L16.6883 8L15.75 7.1"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <ellipse
                              cx="8"
                              cy="13.5"
                              rx="2.5"
                              ry="2.5"
                              stroke="#323232"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13 21C13 19.6193 11.8807 18.5 10.5 18.5H5.5C4.11929 18.5 3 19.6193 3 21"
                              stroke="#1D2433"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                      <div className="d-flex flex-column">
                        <p className="p1-light text-dark mb-0">Completed</p>
                        <h3 className="h3-strong mb-0">{this.state.completedCount}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TableGrid
                hasPagination={true}
                fetchTableRecords={(filters) => this.fetchVisitsList(filters)}
                hasHeaderAction={true} //headerProps
                headersProps={{
                  tableRecords: tableRecords,
                  headerButtons: this.getHeaderButtons(),
                  checkBoxchangeHandler: this.checkBoxchangeHandler,
                  selectedAllRecords: selectedAllRecords,
                  setSelectedAllRecords: (bool) =>
                    this.setState({ selectedAllRecords: bool }),
                }}
                {...tableRecords}
                gridEditProps={{
                  formDataInEdit: this.state.formDataInEdit,
                  activeEditId: this.state.activeEditId,
                  onChangeFormDataInEdit: this.onChangeFormDataInEdit,
                }}
              />
          
          </div>
        </div>
        </div>
        </div>
        </div>
      </>
    );
  }
  setCurrentDate = (val, calendarViewType) => {
    this.setState({
      currentDay: val,
      calendarViewType: calendarViewType,
      isCalendarWidgetDate: val,
    });
  };
  submitFiltersHandler = async () => {
    const { filters, tableRecords } = this.state;
    const queryfilters = {
      ...tableRecords.pagination,
      page: 1,
      ...filters,
    };
    await this.fetchVisitsList(queryfilters);
  };
  clearFiltersHandler = async () => {
    this.setState(
      {
        activeCard: 'TOTAL',
        filters: {
          first_name: "",
          last_name: "",
          gender: "",
          company_id: "",
          dob: "",
          visit_status: "Active",
          patient_id: "",
          phone: "",
          patient_id: "",
          identification_type: "",
          identification_number: "",
          clinic_id: "",
          booking_id: "",
          pre_registration_code: "",
          clinic_location_id: "",
        },
      },
      this.submitFiltersHandler
    );
  };
  fetchVisitsList = async (query = {}) => {
    const { Tab, currentDay, calendarParam,activeCustomFilter } = this.state;
    const { tableRecords } = this.state;
    const { params } = this.props;
    const { filters } = this.state;
    const globalFilter = this.props?.globalFilter?.["White Board"] || {};
    let queryString = toQueryString({
      ...tableRecords.pagination,
      ...query,
    });

    queryString = { ...queryString, ...filters, ...globalFilter,...activeCustomFilter };
    const currentDate = formatDate(currentDay);
    queryString.visit_from = currentDate;
    queryString.visit_to = currentDate;
    try {
      this.props.Loader(true);
      let VisitsList = {};
      const activeTab = Tab.find((itm) => itm.isActive == true);
      console.log("activetab", activeTab);

      query = { ...query, ["visit_status"]: activeTab?.name ?? "" };
      VisitsList = await VisitsService.getVisitsList(queryString);
      if (!VisitsList) {
        this.setState((prevState) => ({
          tableRecords: {
            ...prevState.tableRecords,
            tableHeaders: this.getTableHeader(),
            tableRows: { type: "default", data: [] },
            pagination: {
              ...prevState.tableRecords.pagination,
              ...query,
              totalRecords: 0,
            },
          },
          calendarRecords: [],
        }));
        this.props.Loader();
        return;
      }
      const visitRows = Array.isArray(VisitsList?.data?.data) ? VisitsList.data.data : [];
      let tableData = [];
      visitRows.forEach((visit) => {
        // Use screen_type if available, otherwise fall back to visit_category
        const categoryForRedirect = visit.screen_type || visit.visit_category;
        const voiceProgressRow = voiceDocProgressFromVisitListRow(visit);
        const voiceUi = getVoiceToolbarUi(voiceProgressRow);
        
        const hyperLink = isSet(params.patientId, null !== null)
          ? {
              href: `/employee/visit-history/${params.patientId}/${params.patientDetails}/${visit.visit_id}`,
              title: "Patient Visit detailed view",
            }
          : isWorkCompVisitCategory(categoryForRedirect)
          ? {
              href: `/visits/emr-details/${visit.visit_id}/white-board`,
              title: "Patient Visit EMR view",
            }
          : {
              href: `/visits/visit-details/${visit.visit_id}/white-board`,
              title: "Patient Visit detailed view",
            };
        tableData = [
          ...tableData,
          {
            employeeIndex: 0,
            isHeading: false,
            rowId: visit.visit_id,
            data: {
              ...visit,
              isActive: false,
              provider_name: {
                value: visit?.primary_provider 
                  ? `${visit.primary_provider.first_name || ''} ${visit.primary_provider.last_name || ''}`.trim() 
                  : '-',
                ...hyperLink,
              },
              employee_name: [
                {
                  className: "text-sm",
                  acl:PERMISSIONS.WHITE_BOARD.EDIT,
                  label:
                    visit.employee.first_name + " " + visit.employee.last_name,
                  clickHandler: () => this.detailViewModal(visit.employee_id),
                },
              ],
              clinic: {
                value: visit?.employee?.clinic?.name,
                ...hyperLink,
              },
              company: { value: visit?.company?.name, ...hyperLink },
              visit_date: {
                value: visit.visit_date,
                ...hyperLink,
              },
              visit_category: {
                value: getShortenedVisitCategoryName(visit.visit_category),
                ...hyperLink,
              },
              // visit_status: [
              //   {
              //     className: "text-sm",
              //     // iconType: "Edit",
              //     label: visit.visit_status,
              //     acl: "any",
              //     title: "Update Status",
              //     clickHandler: (e) =>
              //       this.openMiniPopup(visit.visit_id, visit.visit_status),
              //   },],
              visit_status: {
                value: visit.visit_status,
                className: "text-sm",
                // iconType: "Edit",
                label: visit.visit_status,
                acl: PERMISSIONS.WHITE_BOARD.EDIT,
                title: "Update Status",
                clickHandler: (e) =>
                  this.openMiniPopup(visit.visit_id, visit.visit_status),
              },
              visit_time: { value: visit.visit_time, ...hyperLink },
              visit_reason: { value: visit.visit_reason, ...hyperLink },
              formatted_los_time: {
                value: visit.formatted_los_time,
                ...hyperLink,
              },
              created_at: visit.created_at,
              updated_at: visit.updated_at,
              action: [
                {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  // iconType: "NewDetailViewIcon",
                  iconType: "Search",
                  label: "",
                  acl: PERMISSIONS.WHITE_BOARD.EDIT,
                  title: "Detail view",
                  clickHandler: () =>
                    this.visitDetailViewModal(visit.visit_id, visit.employee),
                },
                {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  // iconType: "NewChartIcon",
                  iconType: "ActivityChart",
                  iconSize: 15,
                  acl: PERMISSIONS.WHITE_BOARD.EDIT,
                  title: "Chart",
                  href: hyperLink.href,
                  ...hyperLink,
                },
                {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  iconType: "NewFollowUpIcon",
                  acl: PERMISSIONS.WHITE_BOARD.FOLLOW_UP,
                  accessType:"Hide",
                  title: "Follow Up",
                  label: "Add Follow-Up",
                  clickHandler: () => this.followUpModelHandler(visit.visit_id),
                },
                {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  // iconType: "NewDetailViewIcon",
                  iconType: `Question_${visit.questionnaires_status}`,
                  title:
                  visit.questionnaires_status === "Default"
                    ? "Questionnaires Not Available"
                    : visit.questionnaires_status === "Completed"
                    ? "Questionnaires are completed"
                    : visit.questionnaires_status === "Sent"
                    ? "Questionnaires are already sent"
                    : visit.questionnaires_status === "Available"
                    ? "Questionnaires are not sent yet"
                    : visit.questionnaires_status,
                
                  label: "",
                  acl: PERMISSIONS.WHITE_BOARD.EDIT,
                  disabled: visit.questionnaires_status === "Default",
                  clickHandler: () => {
                    const blockedStatuses = ["Default", "Completed", "Sent"];
                    if (!blockedStatuses.includes(visit.questionnaires_status)) {
                      this.SendQuestionnaire(visit.visit_id);
                    }
                  },                  
                },
                {
                  className: "btn btn-icon btn-transparent-dark",
                  iconType: voiceUi.iconType,
                  iconSize: 20,
                  label: "",
                  title: isVoiceTranscriptionListCategory(categoryForRedirect)
                    ? voiceUi.title
                    : "Transcription Not Available.",
                  acl: PERMISSIONS.WHITE_BOARD.EDIT,
                  disabled: !isVoiceTranscriptionListCategory(categoryForRedirect),
                  clickHandler: () => {
                    if (!isVoiceTranscriptionListCategory(categoryForRedirect)) return;
                    this.openTranscriptionWorkflow(visit);
                  },
                },
                {
                  // iconType:"NewMeatBallIcon",
                  iconType: "MeatBall",
                  title: "More",
                  iconDropDownList: [
                    // {
                    //   className: "btn btn-icon px-1 btn-transparent-dark",
                    //   // iconType: "NewLabsIcon",
                    //   iconType: "Labs Order",
                    //   title: "Add Lab",
                    //   label: "Add Lab",
                    //   acl: `${
                    //     visit.visit_category == "Employer Services - Labs"
                    //       ? PERMISSIONS.WHITE_BOARD.ADD_LAB
                    //       : ""
                    //   }`,
                    //   disableButtonTitle: "Add Lab",
                    //   clickHandler: () => {
                    //     const chartHref = isSet(params.patientId, null) != null
                    //       ? hyperLink.href
                    //       : isWorkCompVisitCategory(categoryForRedirect)
                    //         ? `/visits/emr-details/${visit.visit_id}/visits`
                    //         : `/visits/visit-details/${visit.visit_id}`;
                    //     this.props.navigate(chartHref);
                    //   },
                    // },
                    // {
                    //   className: "btn btn-icon btn-transparent-dark",
                    //   // iconType: "NewAddPhysicalIcon",
                    //   iconType: "AddPhysical",
                    //   label: "Add Physical and Drug Screen",
                    //   disableButtonTitle: "Add Physical and Drug Screen",
                    //   disableButtonTitle: "Add Physical and Drug Screen",
                    //   acl: isLaboratoryVisitCategory(visit.visit_category)
                    //     ? ""
                    //     : visit.has_physical
                    //     ? ""
                    //     : PERMISSIONS.WHITE_BOARD.ADD_PHYSICAL_SCREEN,
                    //   title: "Add Physical and Drug Screen",
                    //   clickHandler: () =>
                    //     this.addPhysicalToogleHandler(
                    //       visit.visit_id,
                    //       visit.company_id
                    //     ),
                    // },
                    {
                      className: "btn btn-icon btn-transparent-dark",
                      iconType: "ChatSquareTextFill",
                      iconColor:"#8F909E",
                      label: "Send Message",
                      title: "Send Message",
                      acl: PERMISSIONS.WHITE_BOARD.SEND_MESSAGE,
                      accessType:"Hide",
                      clickHandler: () =>
                        this.sendTaskModalHandler(hyperLink.href),
                    },
                    {
                      className: "btn btn-icon btn-transparent-dark",
                      iconType: "Remove",
                      label: "Delete",
                      title: "Delete",
                      acl: PERMISSIONS.WHITE_BOARD.DELETE,
                      isDelete: true,
                      contentTitle: visit.has_physical ? "Warning" : null,
                      content: visit.has_physical
                        ? "This visit has some associated activities.  Are you sure you want to delete this record?"
                        : null,
                      clickHandler: () => this.deleteHandler(visit.visit_id),
                    },
                    
                  ],
                },
              ],
            },
          },
        ];
      });
      this.setState((prevState) => ({
        tableRecords: {
          ...prevState.tableRecords,
          tableHeaders: this.getTableHeader(),
          tableRows: {
            type: "default",
            data: tableData,
          },
          pagination: {
            ...prevState.tableRecords.pagination,
            ...query,
            totalRecords: VisitsList.pagination.totalCount,
          },
        },
        calendarRecords: tableData,
      }));

      this.props.Loader();
    } catch (e) {
      console.log(e);
      this.props.Loader();
    }
  };
  updateFeildData = async (key, id, value) => {
    const payload = { [key]: value };
    let response;
    let validation = {};
    let succMsg = "Updated Successfully";
    if (key == "visit_status") {
      response = await VisitsService.updateVisitStatus(null, id, payload);
      succMsg = "Visit Status Updated Successfully ";
    }
    if (key == "billing_status") {
      response = await VisitsService.updateVisitBillingStatus(id, payload);
      succMsg = "Billing Status Updated Successfully ";
    }
    if (response.status && response.status == "ERROR") {
      if (isObject(response.data)) {
        for (let key in response.data) {
          validation = {
            ...validation,
            [key]: response.data[key].join(","),
          };
        }
      }
    } else {
      this.props.Toast.success(succMsg);
      this.fetchVisitsList({}, false);
     if (key == "visit_status") {
        this.fetchDailyTotalCount();
        this.fetchStatusCounts();
      }
      
    }
    return validation;
  };

  getTableHeader = () => {
    return [
      {
        label: "",
        name: "ALL",
        key: "isActive",
        type: "checkBox",
        changeHandler: this.checkBoxchangeHandler,
      },
      // {
      //   label: "Visit Date",
      //   key: "visit_date",
      //   type: "",
      //   inputType: "Date",
      //   sortName: 'visit_date'
      // },
      {
        label: "Visit Time",
        key: "visit_time",
        type: "",
        sortName: "visit_time",
        style: { minWidth: "120px" },
      },
      // {
      //   label: "Registration",
      //   key: "registration",
      //   type: "",
      // },
      {
        label: "Provider",
        type: "",
        key: "provider_name",
        sortName: "provider_name",
      },
      {
        label: "Patient",
        type: "Actions",
        key: "employee_name",
        sortName: "employee_name",
      },
      // {
      //   label: "Clinic",
      //   key: "clinic",
      // },
      {
        label: "Company",
        key: "company",
      },

      {
        label: "Visit category",
        key: "visit_category",
        type: "",
        options: this.state.visitCategoryOptions,
        inputType: "SelectList",
        sortName: "visit_category",
        style: { minWidth: "120px" },
      },
      {
        label: "Visit Status",
        key: "visit_status",
        // type: "Actions",
        type: "FieldEdit",
        // options: this.state.visitStatusOption,
        options: this.props.visitStatus,
        inputType: "SelectList",
        sortName: "visit_status",
        onSave: this.updateFeildData,
        style: { minWidth: "120px" },
      },
      ,
      // {
      //   label: "Reason",
      //   key: "visit_reason",
      //   type: "",
      //   inputType: "TextArea",
      //   sortName: 'visit_reason'
      // }
      {
        label: "LOS",
        key: "formatted_los_time",
        type: "",
        inputType: "TextArea",
        sortName: "formatted_los_time",
      },
      { label: "Action", key: "action", type: "Actions" },
      // Add more columns as needed
    ];
  };
  visitDetailViewModal = (
    visitId = null,
    snapEmployeeDetails = null,
    fetch = false
  ) => {
    if (fetch) {
      this.fetchVisitsList();
    }
    this.setState((oldState) => ({
      isVisitDetailViewOpen: !oldState.isVisitDetailViewOpen,
      visitDetailViewId: visitId,
      snapEmployeeDetails: snapEmployeeDetails,
    }));
  };
  deleteHandler = async (visitId, multipleDelete = false) => {
    if (multipleDelete) {
      visitId = getActiveIds(this.state.tableRecords);
    }
    try {
      await VisitsService.deleteVisits(visitId);
      this.props.Toast.success("Visit Deleted successfully");
      this.fetchVisitsList();
      this.fetchDailyTotalCount(); 
       this.fetchStatusCounts();
      // this.props.Toast.success('Employee Deleted Succesfully');
      //   }
    } catch (e) {}
  };
  editHandler = (rowId, data) => {
    // console.log("rowId",rowId,"data",data);
    if (rowId == null) {
      this.setState({ activeEditId: "", formDataInEdit: {} });
      return false;
    }
    this.setState({
      activeEditId: rowId,
      formDataInEdit: data,
    });
  };
  onChangeFiltersHandler = (key, val) => {
    const { filters } = this.state;
    let updatedFilters = { ...filters };
    if (key === "clinic_id") {
      updatedFilters["clinic_location_id"] = "";
    }
    this.setState(
      {
        filters: {
          ...updatedFilters,
          [key]: val,
        },
      },
      this.submitFiltersHandler
    );
  };
  addLabToogleHandler = (visitId = null) => {
    this.setState({
      isLabModelOpen: !this.state.isLabModelOpen,
      visitDetailViewId: visitId,
    });
  };
  checkBoxchangeHandler = (value, { e }, rowId = "") => {
    if (!rowId) {
      rowId = e.target.id;
    }
    const { tableRows } = this.state.tableRecords;
    let updatedData;
    if (rowId == "ALL") {
      updatedData = tableRows.data.map((item) => {
        item.data.isActive = value;
        return item;
      });
      this.setState({
        selectedAllRecords: false,
      });
    } else {
      updatedData = tableRows.data.map((item) => {
        if (item.rowId === rowId) {
          item.data.isActive = value;
        }
        return item;
      });
    }
    const allSelected = updatedData.every((item) => item.data.isActive == 1);
    const allCheckbox = document.getElementById("ALL");
    if (allCheckbox) {
      allCheckbox.checked = allSelected;
    }
    this.setState((prevState) => ({
      tableRecords: {
        ...prevState.tableRecords,
        tableRows: {
          data: updatedData,
        },
      },
    }));
  };
  filterOnClick = () => {
    this.setState(
      {
        filterOpen: !this.state.filterOpen,
      },
      () => {
        if (document.body.classList.contains("filterOpened")) {
          document.body.classList.remove("filterOpened");
          // menuToggleElement.removeClass('active');
        } else {
          document.body.classList.add("filterOpened");
        }
      }
    );
  };
  filterCloseHandler = (isClear = true) => {
    if (isClear) {
      this.clearFiltersHandler();
    } else {
      this.setState(
        {
          filterOpen: false,
        },
        () => {
          if (document.body.classList.contains("filterOpened")) {
            document.body.classList.remove("filterOpened");
            // menuToggleElement.removeClass('active');
          } else {
            document.body.classList.add("filterOpened");
          }
        }
      );
    }
  };
  detailViewModal = (empId) => {
    this.setState((oldState) => ({
      isDetailViewOpen: !oldState.isDetailViewOpen,
      detailViewId: empId,
    }));
    if (empId == null) {
      this.fetchVisitsList();
    }
  };
  // fetchVisitStatus = async () => {
  //   try {
  //     const data = await LookupService.getLookupByKey(VISIT_STATUS);
  //     let visitStatusArr = [{ label: '-Visit Status-', value: '' }];
  //     data.forEach((item) => {
  //       visitStatusArr.push({
  //         label: item.value,
  //         value: item.value
  //       });
  //     });
  //     this.setState({ visitStatusOption: visitStatusArr });
  //   } catch (e) {
  //   }
  // }
  followUpModelHandler = (visit_id = "") => {
    this.setState({
      isFollowUpModelOpen: !this.state.isFollowUpModelOpen,
      visitDetailViewId: visit_id,
    });
  };
  sendTaskModalHandler = (navigationLink = null) => {
    this.setState({
      sendTaskModalOpen: true,
      selectedVisitNavigationLink: navigationLink,
    });
  };

  /**
   * Purpose: Opens the voice-first transcription modal for a whiteboard visit row
   * Inputs: visit (object from visits list API, includes visit_id and employee)
   * Output: void — updates modal state
   */
  openTranscriptionWorkflow = (visit) => {
    const visitId = visit?.visit_id;
    if (!visitId) return;
    this.setState({
      showTranscriptionModal: true,
      transcriptionVisitId: visitId,
      transcriptionVisitData: visit,
    });
  };

  /**
   * Purpose: Closes the transcription modal and clears bound visit state
   * Inputs: none
   * Output: void
   */
  closeTranscriptionModal = () => {
    this.setState({
      showTranscriptionModal: false,
      transcriptionVisitId: null,
      transcriptionVisitData: null,
    });
    this.fetchVisitsList({}, false);
  };

  addPhysicalToogleHandler = (visitId = "") => {
    this.setState({
      isPhysicalModelOpen: !this.state.isPhysicalModelOpen,
      visitDetailViewId: visitId,
    });
  };
  SendQuestionnaire = async (visitId) => {
    const { Loader, Toast } = this.props;
    Loader(true);
    try {
      const response = await VisitsService.getQuestionnaireList({
        visit_id: visitId,
        baseUrl: process.env.REACT_APP_BASEURL,
      });
      if (response?.code === 422 || response?.status === "ERROR") {
        const msg =
          typeof response?.data === "string"
            ? response.data
            : "No questionnaires available to send for this visit.";
        Toast.error(msg);
        return;
      }
      Toast.success("Questionnaire link sent successfully");
      this.fetchVisitsList();
    } catch (err) {
      const msg =
        err?.data?.data ||
        err?.data?.message ||
        (typeof err?.data === "string" ? err.data : "Failed to send questionnaires");
      Toast.error(msg);
    } finally {
      Loader(false);
    }
  };
  setActiveTab = (val) => {
    let { Tab, filters } = this.state;
    const { label, name, isActive } = val;
    let updatedTab = Tab.map((item) => {
      if (item.label == label) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    this.setState(
      (prevState) => ({
        Tab: updatedTab,
        filters: { ...prevState.filters, ["visit_status"]: name },
      }),
      () => this.submitFiltersHandler()
    );
  };
  setActiveScheduled = (val) => {
    let { scheduledType, filters } = this.state;
    const { label, name, isActive } = val;
    let updatedTab = scheduledType.map((item) => {
      if (item.label == label) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    this.setState(
      (prevState) => ({
        scheduledType: updatedTab,
        filters: { ...prevState.filters, ["is_scheduled_visit"]: name },
      }),
      () => this.submitFiltersHandler()
    );
  };
  anyCheckboxSelected = () => {
    const { tableRows } = this.state.tableRecords;
    if (!tableRows || !Array.isArray(tableRows.data)) {
      return false;
    }

    return tableRows.data.some(
      (item) => item.data?.isActive === 1 || item.data?.isActive === true
    );
  };
  getHeaderButtons = () => {
    const HeaderButtons = [
      {
        label: "Download Csv",
        clickHandler: () => this.downloadCSV(),
      },
      {
        label: "Delete",
        clickHandler: () => {},
      },
    ];
    return HeaderButtons;
  };
}
NewWhiteboardList.defaultProps = {
  isFromVisitHistory: false,
};

// export default WithRouter(withReduxState(WithRoutify(NewWhiteboardList)));
export default WithRouter(
  withReduxState(WithRoutify(WithDropdownState(NewWhiteboardList)))
);
